export default "__VITE_ASSET__b543WLxP__"